import AssetsDashboardsFilter from './AssetsDashboardsFilter';

export default AssetsDashboardsFilter;
